<p-table
  #dt1
  [value]="productTypes"
  dataKey="id"
  [rows]="50"
  [showCurrentPageReport]="true"
  [rowsPerPageOptions]="[10, 25, 50]"
  [loading]="loading"
  styleClass="p-datatable-customers p-datatable-gridlines "
  [paginator]="true"
  currentPageReportTemplate="Prikaz od {first}. do {last}. tipa proizvoda od ukupno {totalRecords}"
  [globalFilterFields]="['id', 'name']"
>
  <ng-template pTemplate="caption">
    <div class="page-control">
      <span class="p-input-icon-left">
        <i class="pi pi-search"></i>
        <input
          pInputText
          type="text"
          (input)="dt1.filterGlobal($event.target.value, 'contains')"
          placeholder="Pretraži id, ime tipa"
        />
      </span>
      <div class="btn-group">
        <a
          [routerLink]="['add']"
          class="main-btn"
        >Dodaj tip <i class="pi pi-plus"></i></a>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>
        <div class="flex justify-content-between align-items-center">
          Naziv tipa
        </div>
      </th>
      <th>
        <div class="flex justify-content-between align-items-center">
          Kreirano
        </div>
      </th>
      <th style="width: 8rem">
        <div class="flex justify-content-between align-items-center">
          Akcija
        </div>
      </th>
    </tr>
  </ng-template>

  <ng-template
    pTemplate="body"
    let-productType
  >
    <tr>
      <td>
        <span class="image-text">{{ productType.name }}</span>
      </td>
      <td>
        <span class="image-text">{{
          productType.created_at | date: "dd.MM.yyyy"
          }}</span>
      </td>
      <td class="text-center">
        <a
          class="second-btn small-btn mr-2"
          pTooltip="Izmeni"
          tooltipPosition="top"
          [routerLink]="[productType.id, 'edit']"
          [queryParams]="{ name: productType.name }"
        >
          <i class="pi pi-pencil"></i>
        </a>
        <button
          class="second-btn small-btn"
          type="button"
          pTooltip="Izbriši"
          tooltipPosition="top"
          (click)="onDeleteProductType($event, productType.id)"
        >
          <i class="pi pi-trash"></i>
        </button>
      </td>
    </tr>
  </ng-template>

  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="3">Ni jedan tip proizvoda nije pronađen.</td>
    </tr>
  </ng-template>
</p-table>
